module.exports = __webpack_public_path__ + "static/beijingtu_2.bdeae456.png";